// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowListModal-cls1__d8e109e5b16fba998671","cls2":"BulkFollowListModal-cls2__f3c2259d0c50d3d1fdc4 BulkFollowListModal-cls1__d8e109e5b16fba998671"};